<template>
  <div v-if="visible" class="fb-mask" @click.self="close">
    <div class="fb-box">
      <h3>意见反馈</h3>
      <textarea
        v-model="content"
        maxlength="500"
        placeholder="请描述您遇到的问题并记得留下邮箱..."
        class="fb-textarea"
      ></textarea>
      <div class="fb-count">{{ content.length }}/500</div>
      <div class="fb-btns">
        <button class="fb-btn cancel" @click="close">取消</button>
        <button class="fb-btn submit" @click="submit">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'FeedbackModal',
  data() {
    return {
      visible: false,
      content: ''
    }
  },
  methods: {
    open() {
      this.visible = true
      this.content = ''
    },
    close() {
      this.visible = false
      this.content = ''
    },
    async submit() {
      const text = this.content.trim()
      if (!text) {
        this.$showToast('请填写反馈内容')
        return
      }
      if (this.$hasSensitiveWord(text)) {
        this.$showToast('内容包含违规词汇')
        return
      }
      try {
        const res = await request.post('/feedback', { content: text })
        if (res.success) {
          alert('已提交，我们会依情况判断处理。处理结果不再反馈。')
          this.close()
        } else {
          this.$showToast(res.msg || '提交失败')
        }
      } catch (err) {
        console.error(err)
        this.$showToast('提交失败，请重试')
      }
    }
  }
}
</script>

<style scoped>
.fb-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4); /* 稍微调淡一点遮罩，不突兀 */
  backdrop-filter: blur(2px);
  display: flex;
  /* 👇 核心修改 1：取消垂直居中，改为靠上对齐 */
  align-items: flex-start;
  justify-content: center;
  /* 👇 核心修改 2：距离顶部留出 10vh，手机弹键盘也挡不住 */
  padding-top: 10vh; 
  z-index: 9999;
}

.fb-box {
  width: 90%;
  /* 👇 核心修改 3：收窄最大宽度，显得更秀气 */
  max-width: 380px; 
  border-radius: 16px;
  /* 👇 核心修改 4：减小内边距，看起来更紧凑 */
  padding: 20px; 
  
  /* 保持你的云纹底 */
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 420px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.98);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2); /* 阴影收缩一点 */
}

.fb-box h3 {
  margin: 0 0 6px;
  /* 👇 字体稍微缩小 */
  font-size: 16px; 
  color: #d14a4a;
  text-align: center;
  font-family: "STXingkai", "KaiTi", "楷体", sans-serif;
}


.fb-textarea {
  width: 100%;
  /* 👇 核心修改 5：大幅降低输入框高度 */
  min-height: 80px; 
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 8px 10px; /* 内边距缩小 */
  font-size: 13px; /* 字号缩小 */
  resize: none; /* 禁止用户手动拉大，避免撑破 */
  font-family: inherit;
  background: rgba(255, 255, 255, 0.7);
}

.fb-textarea:focus {
  border-color: #409eff;
  outline: none;
  background: #fff;
}

.fb-count {
  text-align: right;
  font-size: 11px; /* 字数统计缩小 */
  color: #999;
  margin-top: 4px;
}

.fb-btns {
  display: flex;
  justify-content: center; /* 按钮居中排布 */
  gap: 16px;
  margin-top: 16px;
}

/* 👇 核心修改 6：按钮大瘦身 */
.fb-btn {
  width: 90px; /* 固定小宽度，不再全屏撑满 */
  height: 32px; /* 高度降低 */
  padding: 0; 
  border-radius: 6px;
  border: none;
  font-size: 13px; /* 字号缩小 */
  cursor: pointer;
  transition: all 0.2s;
}

/* 取消按钮：改成灰底黑字，或者浅红底 */
.fb-btn.cancel {
  background: #f5f7fa;
  color: #606266;
  border: 1px solid #dcdfe6;
}
.fb-btn.cancel:hover {
  background: #e4e7ed;
}

/* 提交按钮：保留蓝色，但稍微调窄 */
.fb-btn.submit {
  background: #409eff;
  color: #fff;
}
.fb-btn.submit:hover {
  background: #337ecc;
}
</style>